"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetAvatarList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const use_promise_1 = require("../../../../hook/use-promise");
const user_1 = require("../../../../network/user");
const material_1 = require("@mui/material");
const avatar_renderer_1 = require("../../../../component/avatar/avatar-renderer");
const use_lazy_promise_1 = require("../../../../hook/use-lazy-promise");
const error_layout_1 = require("../../../../component/error-layout");
const user_context_1 = require("../../../../context/user-context");
const alert_context_1 = require("../../../../context/alert-context");
exports.PresetAvatarList = (0, react_1.memo)(({ sx }) => {
    const { result: presetAvatars, status: getPresetAvatarsStatus, error: getPresetAvatarsError, } = (0, use_promise_1.usePromise)(user_1.getPresetAvatars);
    const { status: updateAvatarStatus, error: updateAvatarError, execute: executeUpdateAvatar, } = (0, use_lazy_promise_1.useLazyPromise)(user_1.updateUserMeta);
    const { showAlert } = (0, alert_context_1.useAlert)();
    const theme = (0, material_1.useTheme)();
    const { userMeta } = (0, user_context_1.useUserMeta)();
    const { refresh: refreshUserMeta } = (0, user_context_1.useUserUpdate)();
    const [updatingAvatar, setUpdatingAvatar] = (0, react_1.useState)(null);
    const handleClick = (0, react_1.useCallback)((avatar) => {
        setUpdatingAvatar(avatar.id);
        executeUpdateAvatar({ avatarId: avatar.id });
    }, [executeUpdateAvatar]);
    (0, react_1.useEffect)(() => {
        if (updateAvatarStatus === use_lazy_promise_1.FetchStatus.Success) {
            setUpdatingAvatar(null);
            refreshUserMeta();
        }
        else if (updateAvatarStatus === use_lazy_promise_1.FetchStatus.Error) {
            setUpdatingAvatar(null);
            showAlert((updateAvatarError === null || updateAvatarError === void 0 ? void 0 : updateAvatarError.message) || "Failed to update avatar", alert_context_1.AlertType.Error);
        }
    }, [
        updateAvatarStatus,
        refreshUserMeta,
        showAlert,
        updateAvatarError === null || updateAvatarError === void 0 ? void 0 : updateAvatarError.message,
    ]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", flexWrap: "wrap", height: "100%", alignItems: "center", spacing: 1, justifyContent: "flex-end", useFlexGap: true, sx: sx, children: [getPresetAvatarsStatus == use_lazy_promise_1.FetchStatus.Success &&
                presetAvatars &&
                presetAvatars.map((avatar) => ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                        position: "relative",
                        width: theme.spacing(4),
                        height: theme.spacing(4),
                    }, children: [(0, jsx_runtime_1.jsx)(avatar_renderer_1.AvatarRenderer, { avatar: avatar, sx: {
                                width: "100%",
                                height: "100%",
                                cursor: "pointer",
                                border: `2px solid ${userMeta.avatar.id === avatar.id
                                    ? theme.palette.primary.main
                                    : "transparent"}`,
                                position: "absolute",
                                top: 0,
                                left: 0,
                            }, onClick: () => handleClick(avatar) }, avatar.id), updatingAvatar === avatar.id && ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: theme.spacing(4), sx: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                zIndex: 1,
                            } }))] }, avatar.id))), getPresetAvatarsStatus === use_lazy_promise_1.FetchStatus.Loading && ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: theme.spacing(4) })), getPresetAvatarsStatus === use_lazy_promise_1.FetchStatus.Error && ((0, jsx_runtime_1.jsx)(error_layout_1.ErrorLayout, { errorMessage: (getPresetAvatarsError === null || getPresetAvatarsError === void 0 ? void 0 : getPresetAvatarsError.message) ||
                    " Failed to load avatars.  Please try again later." }))] }));
});
exports.PresetAvatarList.displayName = "PresetAvatarList";
